import { BlockQuoteIcon } from "shared/components/Icons";
import { MaxWidth } from "shared/components/MaxWidth";
import { MEDIUM } from "shared/utils/constants";
import styles from "./BlockQuote.module.css";

export const BlockQuoteContainer = ({ cite, quote, size = MEDIUM }) => (
  <div className="BlockQuoteContainer">
    <MaxWidth size={size}>
      <BlockQuote cite={cite} quote={quote} />
    </MaxWidth>
  </div>
);

export const BlockQuote = ({ cite, quote }) => (
  <blockquote className={styles.container}>
    <span className={styles.iconWrapper}>
      <BlockQuoteIcon />
    </span>
    <p className={styles.quote}>{quote}</p>
    {cite && <footer className={styles.footer}>- {cite}</footer>}
  </blockquote>
);
